<template>
  <GridContainer
    small
    class="footer-columns"
  >
    <FooterColumn
      headline="Wir helfen Dir weiter"
      class="footer-columns__column"
    >
      <ul class="footer-columns__list list">
        <template
          v-for="(helpLink, index) in helpLinks"
          :key="index"
        >
          <li class="list__element list__element--icon">
            <LinkButton
              class="footer-columns__link"
              tag="nuxt-link"
              no-styling
              :to="helpLink.to"
              :is-external="helpLink.isExternal"
              :rel="helpLink.isExternal ? 'noopener' : ''"
              tealium-suffix="footer"
            >
              <SvgIcon
                :image="helpLink.icon"
                class="list__icon"
              />
              {{ helpLink.text }}
            </LinkButton>
          </li>
        </template>
        <li>
          <LinkButton
            class="footer-columns__btn-widerruf"
            tag="nuxt-link"
            to="/hilfe/lieferstatus-und-retoure"
            variant="secondary"
            label="Bestellung widerrufen"
          />
        </li>
      </ul>
    </FooterColumn>
    <FooterColumn
      headline="Sicher online bestellen und bezahlen"
      class="footer-columns__column"
    >
      <ul class="footer-columns__list list">
        <li class="list__element list__element--dashed">Geprüfte Sicherheit durch TeleSec</li>
        <li class="list__element list__element--dashed">Sichere Zahlung mit SSL-Verschlüsselung</li>
        <li class="list__element list__element--dashed">Schnelle Lieferzeiten</li>
        <li class="list__element list__element--dashed">Datenschutz nach deutschem Recht</li>
      </ul>
      <FooterPayment />
    </FooterColumn>
    <FooterColumn
      headline="Häufig gesuchte Hersteller"
      class="footer-columns__column"
    >
      <FooterFeaturedBrands />
    </FooterColumn>
  </GridContainer>
</template>

<script setup lang="ts">
import { GridContainer, LinkButton } from '@i22team/td-longtail-vue-components';

import IconFacebook from '~/assets/images/facebook.svg';
import IconNewsletter from '~/assets/images/icon-newsletter.svg';
import IconPhone from '~/assets/images/phone.svg';
import IconSupport from '~/assets/images/icon-support.svg';
import IconTelekomHilft from '~/assets/images/telekom-hilft.svg';
import IconTelekomShop from '~/assets/images/icon-shop.svg';
import IconHandyHilfe from '~/assets/images/icon-handyhilfe.svg';
import IconRetoure from '~/assets/images/icon-retoure.svg';

import FooterColumn from './footer-column.vue';
import FooterPayment from './footer-payment.vue';
import FooterFeaturedBrands from './footer-featured-brands.vue';
import SvgIcon from '~/components/svg-icon.vue';

const helpLinks = [
  {
    icon: IconPhone,
    isExternal: false,
    to: '/kontakt',
    text: 'Kontakt',
  },
  {
    icon: IconRetoure,
    isExternal: false,
    to: '/hilfe/lieferstatus-und-retoure',
    text: 'Lieferstatus & Retoure',
  },
  {
    icon: IconFacebook,
    isExternal: true,
    to: 'https://www.facebook.com/deutschetelekom ',
    text: 'Facebook',
  },
  {
    icon: IconTelekomHilft,
    isExternal: true,
    to: 'https://telekomhilft.telekom.de/',
    text: 'Telekom hilft Community',
  },
  {
    icon: IconTelekomShop,
    isExternal: true,
    to: 'https://shopsuche.telekomshop.de/',
    text: 'Telekom Shop finden',
  },
  {
    icon: IconSupport,
    isExternal: true,
    to: 'https://www.telekom.de/hilfe/smartphone-tablet-mehr',
    text: 'Hilfen für Dein Handy, Smartphone und Tablet',
  },
  {
    icon: IconNewsletter,
    isExternal: true,
    to: 'https://www.telekom.de/mehr-magenta/newsletter',
    text: 'Telekom Newsletter',
  },
  {
    icon: IconHandyHilfe,
    isExternal: true,
    to: 'https://www.telekom.de/optionsuebersicht/festnetz',
    text: 'Persönliche Unterstützung für Dein Handy & Co.',
  },
];
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.footer-columns {
  padding-bottom: 2rem;
  display: grid;
  grid-template-columns: 1fr;
  padding-inline: 1rem;
  gap: 3rem 1rem;
  max-width: 1140px;

  @include mq($mq-md) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  }

  &__list {
    @include font-size(16px, 27px);
    display: inline-block;

    @include mq($mq-md) {
      margin-bottom: 0;
    }

    // Override
    .list__element {
      padding-bottom: 10px;
    }

    :deep(.link-button__icon) {
      display: none;
    }
  }

  &__link {
    display: inline-block;

    &:after {
      margin-left: 0.5em;
    }
    &:hover {
      text-decoration: 1px underline;
    }
  }

  &__icon {
    height: 4.5rem;
    margin-bottom: calculate-rem(10px);
    margin-right: calculate-rem(20px);
    width: 4.5rem;
    float: left;
  }

  &__btn-widerruf {
    margin-top: 0.5rem;
  }
}
</style>
